import React, { useContext, useEffect, useState } from "react";
import BannerCost from "../../../Assets/Images/BCost.png";
import imagePath from "../../CSS/imagePath";

import axios from "axios";
import moment from "moment";
import swal from "sweetalert";

import { Markup } from "interweave";
import { useHistory, useLocation } from "react-router-dom";
import PaymentModal1 from "../../Modal/PaymentModal/PaymentModal1";
import { serverInfo } from "../../../App";

const QARegister = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [modalShow, setModalShow] = React.useState(false);

  const [oldData, setOldData] = useState([]);
  const [userInfo, setUserInfo] = useState([]);
  const [eventInfo, setstate] = useState({});
  const [QnaInfo, setQnaInfo] = useState([]);
  const [starInfo, setStarInfo] = useState({});
  const [formdata, setFormdata] = useState({
    name: "",
    date_b: "",
    phone: "",
    location: "",
    comment: "",
    error_list: [],
  });

  const [showCard, setShowCard] = React.useState(false);
  const history = useHistory();
  const location = useLocation();
  const [showdownCard, setShowdownCard] = useState(false);
  const [firstCard, setFirstCard] = useState(true);
  const [formName, setFormName] = useState();
  const [formPhone, setFormPhone] = useState();
  const [status, setStatus] = useState(false);

  useEffect(() => {
    setOldData(location.state.data);
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/user/sinlgeQna/${location.state.data.id}`).then((res) => {
        if (res.data.status === 200) {
          setQnaInfo(res.data.liveChat);
          setStarInfo(res.data.starInfo);
          setStatus(true);
        }
      });
      localStorage.getItem("auth_token") &&
        axios.get(`/api/user_info`).then((res) => {
          if (res.data.status === 200) {
            setUserInfo(res.data.users);
            setStatus(true);
          }
        });
    });
  }, [location]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormdata((prev) => {
      return { ...prev, [name]: value };
    });
  };
  function handleClick(e) {
    e.preventDefault();
    setShowCard(true);
  }

  const [passwordInput, setPassword] = useState("");

  const handlePasswordInput = (e) => {
    e.persist();
    setPassword(e.target.value);
  };

  //form validation
  function userVerify(e) {
    //   alert('hello')
    e.preventDefault();

    const passData = {
      password: passwordInput,
    };

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/verify_user`, passData).then((res) => {
        if (res.data.status === 200) {
          setModalShow(true);
          setShowdownCard(true);
          setFirstCard(false);
        } else {
          swal("Warning", res.data.message, "warning");
        }
      });
    });
  }

  return (
    <>
      <div className="bg-dark card my-4 px-3">
        <div className="card-body">
          <h5 className="card-title text-warning">
            Q&A Session With {starInfo?.first_name} {starInfo?.last_name}
          </h5>
          <div className="star-line"></div>
          <div className="row mt-3 justify-content-between">
            <div className="col-md-5 justify-content-center">
              <div className=" bg-dark border-0 card CostBD w-100">
                <img
                  src={imageCdnUrl + QnaInfo.banner}
                  alt=""
                  className="mb-3 rounded-3"
                />
                <h5 className="DAteH">
                  {moment(QnaInfo.event_date).format("LL")}
                </h5>
              </div>

              <center>
                <span className="text-warning fw-bold">Cost </span>
                <br />
                <img src={imagePath.Under} alt="" />
              </center>

              <div className="bg-dark border-0 card CostBD mb-3">
                <img src={BannerCost} alt="" className="" />
                <div className="CostDBs">
                  <h4 className="CodX fw-bold px-3">Cost for the Q&A:</h4>
                  <h2 className="CodY fw-bold px-3">{QnaInfo.fee}</h2>
                </div>
              </div>
            </div>

            <div className="col-md-5">
              <div className=" bg-dark border-0  card ">
                <div className="d-flex mb-2">
                  <div className="col-md-2 fw-bold text-light">Star</div>
                  <div className=" col-md-8 text-light">
                    :&nbsp;&nbsp;&nbsp;&nbsp; {starInfo?.first_name}{" "}
                    {starInfo?.last_name}
                  </div>
                </div>

                <div className="d-flex mb-2">
                  <div className="col-md-2 fw-bold text-light">Event Date</div>
                  <div className=" col-md-8 text-light">
                    :&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                    {moment(QnaInfo.event_date).format("LL")}
                  </div>
                </div>
                <div className="d-flex mb-2">
                  <div className="col-md-2 fw-bold text-light">Time</div>
                  <div className=" col-md-8 text-light">
                    :&nbsp;&nbsp;&nbsp;&nbsp;
                    {moment(QnaInfo.start_time, "hh:mm").format(
                      "hh:mm a"
                    )} - {moment(QnaInfo.end_time, "hh:mm").format("hh:mm a")}
                  </div>
                </div>
                <div className="d-flex mb-2">
                  <div className="col-md-2 fw-bold text-light">Fees</div>
                  <div className=" col-md-8 text-light">
                    :&nbsp;&nbsp;&nbsp;&nbsp; {QnaInfo.fee}
                  </div>
                </div>
              </div>

              <div className="mt-3 bg-dark border-0  card ">
                <h5 className="mb-4 text-light fw-bold">Instruction</h5>

                <p className="text-light">
                  <Markup content={QnaInfo.instruction} />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-dark card my-4 px-3 ">
        <div className="card-body">
          <h5 className="card-title text-warning">Registration</h5>
          <div className="star-line"></div>

          <form onSubmit={userVerify}>
            <div className="row mt-3 justify-content-between">
              <div className="col-md-6 mb-3">
                <div className="mx-2 dg-dark w-100">
                  <label className="text-light mb-2">Name</label>
                  <input
                    type="text"
                    name="name"
                    value={userInfo.first_name}
                    className="InputBQA from-control text-red  w-100"
                  />
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="mx-2 dg-dark w-100">
                  <label className="text-light mb-2">Phone</label>
                  <input
                    type="text"
                    name="phone"
                    value={userInfo.phone}
                    className="InputBQA from-control text-red  w-100"
                  />
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <div className="mx-2 dg-dark w-100">
                  <label className="text-light mb-2">Email</label>
                  <input
                    type="text"
                    name="email"
                    value={userInfo.email}
                    className="InputBQA from-control text-red  w-100"
                  />
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="mx-2 dg-dark w-100">
                  <label className="text-light mb-2">Password</label>
                  <input
                    type="password"
                    name="password"
                    onChange={handlePasswordInput}
                    className="InputBQA from-control text-red  w-100"
                  />
                </div>
              </div>
            </div>
            <div className="row mt-3 justify-content-center">
              <button className="fw-bold btn ButtonAQ">Submit</button>
              <PaymentModal1
                show={modalShow}
                data={QnaInfo}
                onHide={() => setModalShow(false)}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default QARegister;
